import { HttpErrorResponse } from '@angular/common/http';
import { ServiceError } from '../../../../../shared/types/service-error';
import { Unavailable } from '../../../../../shared/types/unavailable';
import { BadRequest } from '../../../../../shared/types/bad-request';
import { NotFound } from '../../../../../shared/types/not-found';
import { notifyMessage } from '../../../../../shared/constants/notify-message';

export class FeasibilityError {
  private _service = 'Feasibility';

  public get message(): string {
    return this.analyze().message;
  }

  constructor(public readonly error: unknown) {}

  public analyze(): Error {
    if (this.isHttpError(this.error)) {
      return this._httpError(this.error);
    }

    if (this.isError(this.error)) {
      return this.error;
    }

    return new ServiceError(this._service);
  }

  public isHttpError(value: unknown): value is HttpErrorResponse {
    return value instanceof HttpErrorResponse;
  }

  public isError(value: unknown): value is Error {
    return value instanceof Error;
  }

  private _httpError(error: HttpErrorResponse): Error {
    if (new Unavailable(error).check()) {
      return new Error(
        `${this._service} Service appears to be unavailable at the moment, please contact support.`
      );
    }

    if (new BadRequest(error).check()) {
      return new Error(
        notifyMessage.errorMessage.FEASIBILITY.FEASIBILITY_NOT_PROCESSED
      );
    }

    if (new NotFound(error).check()) {
      return new Error(
        notifyMessage.errorMessage.FEASIBILITY.FEASIBILITY_NOT_PROCESSED
      );
    }
    return error;
  }
}
